'use strict';

import angular from 'angular';
import CreateTutorController from './create-tutor.controller';

function CreateTutorFactory($uibModal){
	'ngInject';

	return function(){
		return $uibModal.open({
	      template: require('./create-tutor.html'),
	      controller: 'CreateTutorController',
	      controllerAs: 'vm',
	    }).result;
	}
}


export default angular.module('accessApp.CreateTutor', [])
  .controller('CreateTutorController', CreateTutorController)
  .factory('CreateTutorFactory', CreateTutorFactory)
  .name;


// WEBPACK FOOTER //
// ./client/app/modals/create-tutor/index.js